// Cached reads of group reference data. Each function builds the same URL the pages
// used to build inline, fetches once per group per TTL, and shares the in-flight
// request between concurrent callers. Results are deep copies, so callers may
// mutate them freely. Eviction happens in the axios interceptor registered in
// main.js (see src/util/groupDataCache.ts), never from pages.

import axios from 'axios'
import { Auth } from 'aws-amplify'
import apiConfig from '@/api-config'
import { getCached, currentGroupId } from '@/util/groupDataCache'

const API_LOCATION: string = (apiConfig as any).API_LOCATION

async function authHeader(): Promise<Record<string, string>> {
  const session = await Auth.currentSession()
  return { Authorization: session.getIdToken().getJwtToken() }
}

function groupUrl(suffix: string): string {
  const companyId = localStorage.getItem('companyId')
  return `${API_LOCATION}companies/${companyId}/groups/${currentGroupId()}/${suffix}`
}

async function readJson(url: string): Promise<any> {
  const headers = await authHeader()
  const res = await axios.get(url, { headers })
  return res.data
}

export function getGames(): Promise<any[]> {
  return getCached('games', () => readJson(groupUrl('games')))
}

export function getBookingSlotSettings(): Promise<{ custom_statuses: any[]; system_status_overrides: any[] }> {
  return getCached('booking-slot-settings', () => readJson(groupUrl('booking-slot-settings')))
}

export function getSiteSettings(): Promise<any> {
  return getCached('site-settings', () => readJson(`${API_LOCATION}users/site-settings?group=${currentGroupId()}`))
}

export function getResourceCalendarSiteSettings(): Promise<any> {
  return getCached('site-settings:resource-calendar', () =>
    readJson(`${API_LOCATION}users/site-settings?group=${currentGroupId()}&view_type=resource-calendar`),
  )
}

export function getWorkflowStates(): Promise<any[]> {
  return getCached('workflow-states', () => readJson(groupUrl('workflow-states')))
}

export function getPaymentMethods(): Promise<{ payment_methods: any[] }> {
  return getCached('payment-methods', () => readJson(groupUrl('payment-methods')))
}

export function getMe(): Promise<any> {
  return getCached('users-me', () => readJson(`${API_LOCATION}users/me`))
}
